(function () {
  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function init(root) {
    var viewport = root.querySelector("[data-ir-articles-viewport]");
    var controls = root.querySelector("[data-ir-articles-controls]");
    var prevBtn = root.querySelector("[data-ir-articles-prev]");
    var nextBtn = root.querySelector("[data-ir-articles-next]");
    var grid = viewport.querySelector(".ir-related-grid");
    var progressBar = root.querySelector("[data-ir-articles-progress]");
    var progressFill = root.querySelector("[data-ir-articles-progress-fill]");

    if (!viewport || !controls || !prevBtn || !nextBtn || !grid) return;

    var cards = grid.querySelectorAll(".ir-related-card");
    var cardCount = cards.length;
    
    if (cardCount <= 1) {
      controls.style.display = "none";
      return;
    }

    var currentIndex = 0;
    var cardWidth = 0;
    var gap = 0;

    function updateDimensions() {
      if (window.innerWidth <= 768) {
        // Calculate card width based on viewport width
        var style = window.getComputedStyle(grid);
        gap = parseFloat(style.gap) || 0;
        // Card width should be exactly the viewport width minus grid padding
        cardWidth = window.innerWidth; // Full viewport width per card
        controls.style.display = "flex";
      } else {
        controls.style.display = "none";
      }
    }

    function updatePosition() {
      if (window.innerWidth <= 768) {
        var translateX = -(currentIndex * cardWidth);
        grid.style.transition = "transform 0.3s ease";
        grid.style.transform = "translateX(" + translateX + "px)";
        
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex >= cardCount - 1;
        
        // Update progress bar
        if (progressFill && cardCount > 1) {
          var progress = (currentIndex / (cardCount - 1)) * 100;
          progressFill.style.width = progress + "%";
        }
      } else {
        grid.style.transform = "";
        grid.style.transition = "";
        prevBtn.disabled = false;
        nextBtn.disabled = false;
        if (progressFill) progressFill.style.width = "0%";
      }
    }

    function goToSlide(index) {
      currentIndex = clamp(index, 0, cardCount - 1);
      updatePosition();
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    function prevSlide() {
      goToSlide(currentIndex - 1);
    }

    // Touch/drag support
    var startX = 0;
    var currentX = 0;
    var isDragging = false;
    var threshold = 50;

    function handleStart(e) {
      if (window.innerWidth > 768) return;
      isDragging = true;
      startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
      grid.style.transition = "none";
    }

    function handleMove(e) {
      if (!isDragging || window.innerWidth > 768) return;
      e.preventDefault();
      currentX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
      var diff = currentX - startX;
      var translateX = -(currentIndex * cardWidth) + diff;
      grid.style.transform = "translateX(" + translateX + "px)";
    }

    function handleEnd() {
      if (!isDragging || window.innerWidth > 768) return;
      isDragging = false;
      grid.style.transition = "";
      
      var diff = currentX - startX;
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          prevSlide();
        } else {
          nextSlide();
        }
      } else {
        updatePosition();
      }
    }

    // Event listeners
    prevBtn.addEventListener("click", prevSlide);
    nextBtn.addEventListener("click", nextSlide);

    // Touch events
    viewport.addEventListener("touchstart", handleStart, { passive: false });
    viewport.addEventListener("touchmove", handleMove, { passive: false });
    viewport.addEventListener("touchend", handleEnd);

    // Mouse events for desktop drag
    viewport.addEventListener("mousedown", handleStart);
    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mouseup", handleEnd);

    // Resize handler
    window.addEventListener("resize", function() {
      updateDimensions();
      updatePosition();
    });

    // Initialize
    updateDimensions();
    updatePosition();
  }

  // Scroll-triggered fade-in animation
  function initScrollAnimation() {
    var cards = document.querySelectorAll('.ir-related-card');
    
    if (!cards.length) return;
    
    // Create intersection observer
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Add fade-in class with staggered delay
          var index = Array.from(cards).indexOf(entry.target);
          setTimeout(function() {
            entry.target.classList.add('fade-in');
          }, index * 150); // 150ms delay between each card
          
          // Stop observing this element
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    // Observe all cards
    cards.forEach(function(card) {
      observer.observe(card);
    });
  }

  // Initialize all functionality
  document.addEventListener("DOMContentLoaded", function() {
    var sliders = document.querySelectorAll("[data-ir-articles-slider]");
    sliders.forEach(init);
    
    // Initialize scroll animations
    initScrollAnimation();
  });
})();
